import React, { useContext } from 'react';
import { CSVReader } from 'react-papaparse';
import { LabFilesCtx } from 'pages/LabFilesPage';

function LabImportCSV() {
  const { setDataCSV } = useContext(LabFilesCtx);
  const handleOnDrop = (data, file) => {
    const fileName = file.name;
    const Keys = data[0].data;
    const columns = Keys.map((v, idx) => {
      return {
        id: idx,
        label: v,
        field: v,
      };
    });
    const rows = data.slice(1)
      .map((row) => {
        return row.data;
      })
      .map((row) => {
        return row.map((r, idx) => {
          return {
            Key: Keys[idx],
            Value: r,
          };
        });
      })
      .filter((row) => {
        return row.some((attr) => { return 'Sample Name' === attr.Key && !!attr.Value; });
      });
    setDataCSV({ Keys, columns, rows, fileName });
  };

  const handleOnError = (err, file, inputElem, reason) => {
    console.log(err, file, inputElem, reason);
  };

  const handleOnRemoveFile = () => {
    setDataCSV(null);
  };

  return (
    <>
      <div><b>Import Lab CSV</b></div>
      <CSVReader
        onDrop={ handleOnDrop }
        onError={ handleOnError }
        addRemoveButton
        onRemoveFile={ handleOnRemoveFile }
      >
        <span>Drop LAB CSV file here or click to upload.</span>
      </CSVReader>
    </>
  );
}

export default LabImportCSV;
